import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';

import { ArCreditNoteApprovalPanel } from '../components/ar/ArCreditNoteApprovalPanel';
import { CreditNoteList, type CreditNoteListRow } from '../components/ar/CreditNoteList';
import { PageHead } from '../components/layout';
import { useActiveCompanyId, useArCreditNotes } from '../lib/queries';

export const Route = createFileRoute('/ar/credit-notes')({ component: ArCreditNotesPage });

export function ArCreditNotesPage() {
  const companyId = useActiveCompanyId();
  const { data, isPending, error } = useArCreditNotes(companyId);
  // The engine-managed (PENDING) credit note whose central 4-eyes decision panel
  // is open. Set from a row's "ดำเนินการอนุมัติ" action — same flow as /ap.
  const [decideCn, setDecideCn] = useState<CreditNoteListRow | null>(null);

  return (
    <div className="page">
      <PageHead crumbs={['ลูกหนี้การค้า', 'ใบลดหนี้']} title="ใบลดหนี้ (Credit Notes)" />
      {isPending && (
        <div className="muted" style={{ padding: 24, textAlign: 'center' }}>
          กำลังโหลด…
        </div>
      )}
      {error && (
        <div className="neg" style={{ padding: 24, textAlign: 'center' }}>
          โหลดไม่สำเร็จ: {error.message}
        </div>
      )}
      {data && <CreditNoteList creditNotes={data} onDecide={(cn) => setDecideCn(cn)} />}

      {decideCn && companyId && (
        <ArCreditNoteApprovalPanel
          companyId={companyId}
          creditNote={decideCn}
          onClose={() => setDecideCn(null)}
        />
      )}
    </div>
  );
}
